import { Hero } from "@/components/Hero";
import { Services } from "@/components/Services";
import { WhyUs } from "@/components/WhyUs";
import { PortfolioCarousel } from "@/components/PortfolioCarousel";
import { Pricing } from "@/components/Pricing";
import { ContactForm } from "@/components/ContactForm";
import { Footer } from "@/components/Footer";
import { Navigation } from "@/components/Navigation";
import { WhatsAppButton } from "@/components/WhatsAppButton";
import { CookieBanner } from "@/components/CookieBanner";

export const LandingPage = ({ t, lang, changeLang }) => {
  return (
    <div className="min-h-screen bg-[#050505] noise-bg">
      <Navigation t={t} lang={lang} changeLang={changeLang} />
      <main>
        <Hero t={t} />
        <Services t={t} />
        <PortfolioCarousel t={t} />
        <WhyUs t={t} />
        <Pricing t={t} />
        <ContactForm t={t} lang={lang} />
      </main>
      <Footer t={t} />
      <WhatsAppButton lang={lang} />
      <CookieBanner lang={lang} />
    </div>
  );
};

export default LandingPage;
